import type {
  WorkstationSlotBlockApiData,
  WorkstationSlotBlockApiResponses,
  WorkstationSlotDeleteApiData,
  WorkstationSlotDeleteApiResponses,
  WorkstationSlotGetApiData,
  WorkstationSlotGetApiResponses,
  WorkstationSlotListApiData,
  WorkstationSlotListApiResponses,
  WorkstationSlotPatchApiData,
  WorkstationSlotPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getWorkstationSlotUrls = {
  getPaginatedWorkstationSlots: dataEndpoint<WorkstationSlotListApiData, WorkstationSlotListApiResponses>({
    getUrl: (queryParams) => apiUrl('workstation-slots/', queryParams)
  }),
  getWorkstationSlot: dataEndpoint<WorkstationSlotGetApiData, WorkstationSlotGetApiResponses>({
    getUrl: ({ workstationSlotId }) => apiUrl(`workstation-slots/${workstationSlotId}/`)
  }),
  postWorkstationSlotBlock: responseEndpoint<WorkstationSlotBlockApiData, WorkstationSlotBlockApiResponses>({
    getUrl: () => apiUrl('workstation-slots/block/'),
    getBody: (data) => data
  }),
  patchWorkstationSlot: responseEndpoint<WorkstationSlotPatchApiData, WorkstationSlotPatchApiResponses>({
    getUrl: ({ workstationSlotId }) => apiUrl(`workstation-slots/${workstationSlotId}/`),
    getBody: (data) => data
  }),
  deleteWorkstationSlot: dataEndpoint<WorkstationSlotDeleteApiData, WorkstationSlotDeleteApiResponses>({
    getUrl: ({ workstationSlotId }) => apiUrl(`workstation-slots/${workstationSlotId}/`)
  })
};
